var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Города",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      "route-create": "TownCatalogAdd",
      "route-edit": "TownCatalogEdit",
      "route-view": "TownCatalogView",
      "route-path": "/town_catalogs",
      "can-edit": _vm.canEditTownCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ff4262", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ff4262","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Towns/TownCatalogs.vue
// module id = null
// module chunks = 